import axiosInstance from '../api/axiosInstance';

const usernameCache = new Map();

export async function getUsername(userId) {
  if (!userId) return "";

  if (usernameCache.has(userId)) {
    return usernameCache.get(userId);
  }

  try {
    const { data } = await axiosInstance.get(`general/get_username/${userId}`);
    const username = data.username;
    usernameCache.set(userId, username);
    return username;
  } catch (err) {
    console.error("Failed to fetch username:", err);
    return "";
  }
}

export async function getProfilePicture(userId) {
  if (!userId) return null;

  try {
    const { data } = await axiosInstance.get(`general/get_profile_picture/${userId}`);
    const profileUrl = data.profile_url;
    return profileUrl;
  } catch (err) {
    console.error("Failed to fetch profile picture:", err);
    return null;
  }
}